"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const helpers_1 = require("./helpers");
const Requests_1 = require("../../../backend/models/Requests");
class CommentFormImpl extends React.Component {
    constructor(props) {
        super(props);
        this.innerState = new CommentFormInnerState();
        this.state = {
            text: '',
            name: '',
            email: '',
        };
        this.commentChange = this.commentChange.bind(this);
        this.nameChange = this.nameChange.bind(this);
        this.emailChange = this.emailChange.bind(this);
        this.onCommentSubmit = this.onCommentSubmit.bind(this);
    }
    isValid() {
        return this.innerState.email.isValid
            && this.innerState.name.isValid
            && this.innerState.text.isValid;
    }
    commentChange(event) {
        this.innerState.text.setValue(event.target.value);
        this.setState({ text: event.target.value });
    }
    nameChange(event) {
        this.innerState.name.setValue(event.target.value);
        this.setState({ name: event.target.value });
    }
    emailChange(event) {
        this.innerState.email.setValue(event.target.value);
        this.setState({ email: event.target.value });
    }
    onCommentSubmit(event) {
        event.preventDefault();
        if (!this.isValid()) {
            return;
        }
        this.props.postComment(new Requests_1.NewCommentRequest(this.innerState.text.getValue(), this.innerState.name.getValue(), this.innerState.email.getValue(), this.props.postId));
        //this.context.executeAction(BlogActions.postComment, new NewCommentRequest(
        //     this.innerState.text.getValue(),
        //     this.innerState.name.getValue(),
        //     this.innerState.email.getValue(),
        //     this.props.postId));
        this.innerState.name.setValue('');
        this.innerState.text.setValue('');
        this.innerState.email.setValue('');
        this.setState({
            text: '',
            name: '',
            email: '',
        });
    }
}
exports.default = CommentFormImpl;
class CommentFormProps {
}
class CommentFormState {
}
class CommentFormInnerState {
    constructor() {
        this.text = new helpers_1.RequiredStringValue();
        this.name = new helpers_1.RequiredStringValue();
        this.email = new helpers_1.RequiredStringValue();
    }
}
